import { configApiRef, useApi } from '@backstage/core-plugin-api';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import LaunchIcon from '@material-ui/icons/Launch';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: theme.palette.background.default,
      borderRadius: 4,
      padding: theme.spacing(3),
      border: `1px solid ${theme.palette.primary.light}`,
      minHeight: '150px',
    },
    actions: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(1),
      marginTop: theme.spacing(2),
    },
    icon: {
      marginLeft: theme.spacing(1),
    },
  }),
);

export const CreateGitHubTeam = () => {
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const saviyntUrl = configApi.getOptionalString('accessControl.githubTeamAccess.saviyntUrl');

  return (
    <div className={classes.container} role="region" aria-label="GitHub Teams Management">
      <Grid container spacing={2} direction="column">
        <Grid item xs={12}>
          <Typography variant="h6" component="h2">
            Create GitHub Team
          </Typography>
          <Typography variant="subtitle2">
            A GitHub Team organizes users who collaborate on repositories within an organization.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Alert severity="info">
            <Typography variant="body2" component="div" gutterBottom>
              <strong>GitHub Team Management is Changing</strong>
            </Typography>
            <Typography variant="body2" paragraph>
              As part of the Enterprise Managed User (EMU) migration, direct team creation in the AAInternal GitHub
              organization will no longer be allowed in the future. We encourage requesting access to an existing team
              through Saviynt instead.
            </Typography>
            <Typography variant="body2">
              In the meantime, you can still create a new team directly in GitHub if needed.
            </Typography>
            <div className={classes.actions}>
              {saviyntUrl ? (
                <Button
                  color="primary"
                  href={saviyntUrl}
                  rel="noopener noreferrer"
                  size="small"
                  target="_blank"
                  variant="contained"
                >
                  Request Team Access
                  <LaunchIcon aria-hidden="true" className={classes.icon} fontSize="small" />
                </Button>
              ) : null}
              <Button
                color="primary"
                href="https://github.com/orgs/AAInternal/new-team"
                rel="noopener noreferrer"
                size="small"
                target="_blank"
                variant="outlined"
              >
                Create Team in GitHub
                <LaunchIcon aria-hidden="true" className={classes.icon} fontSize="small" />
              </Button>
            </div>
            <Typography variant="caption" color="textSecondary">
              Both links open in a new tab.
            </Typography>
          </Alert>
        </Grid>
      </Grid>
    </div>
  );
};
